/**
 * Boards: `boards:` / `b:` / `board:`.
 * Backed by the local search index (PLAN §12.2) through `deps.client`
 * (`index/indexClient.js` on desktop, `index/webIndexClient.js` on web).
 */
import { Kanban } from 'lucide-react';
import { createIndexProvider } from '../index/indexProvider';

export const SPEC = Object.freeze({ id: 'boards', kinds: ['board'], prefixes: ['boards', 'b', 'board'], labelKey: 'palette.scope.boards', icon: Kanban, order: 60, page: 'task-manager.panel' });

/** @param {{ client: object }} deps */
export default function create(deps) {
  return createIndexProvider(SPEC, deps);
}
